import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { HashLink as Link } from "react-router-hash-link";
import { IBlogSection } from "src/@types/blog";
import { tableOfContentTrns } from "./trns";

interface Props {
  sections: IBlogSection[];
  isSideBar?: boolean;
}

export const TableOfContent: FC<Props> = ({ sections, isSideBar }) => {
  const [activeItem, setActiveItem] = useState("");

  const { t } = useTranslation();

  const table_of_content = sections.map(({ id, title, slug }) => ({
    id,
    title,
    slug,
  }));

  const onClick = (value: string) => {
    setActiveItem(value);
  };

  return (
    <div
      className={cn("flex-1", {
        "sticky top-25 h-max hidden xl:block": isSideBar,
        "mt-5 xl:hidden": !isSideBar,
      })}
    >
      <p
        className={cn(
          "text-purple-base text-xl font-monument-extended font-semibold pb-5",
          { "px-5": isSideBar, "pt-5": !isSideBar }
        )}
      >
        {t(tableOfContentTrns.title)}
      </p>

      <ul className={cn({ "pl-5": isSideBar })}>
        {table_of_content.map(({ id, slug, title }) => (
          <li key={id} onClick={() => onClick(title)}>
            <Link
              className={cn(
                "block text-purple-base text-lg font-bold px-5 py-3 cursor-pointer rounded-20 transition-all duration-300 ease-in-out hover:text-purple-dark",
                {
                  "bg-purple-lighter": title === activeItem,
                  "max-w-max": !isSideBar,
                }
              )}
              to={`#${slug}`}
              smooth
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
